import React, { useState, useEffect } from 'react';

import calendarService from '../../services/CalendarService';
import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import 'react-bootstrap-typeahead/css/Typeahead.css';

const DeleteTrainingModal = (props) => {

    const {show, onHide, fixtureRoomId, selectedFixture, fixtures, setFixtures} = props;

    const [fixtureDetails, setFixtureDetails] = useState(null);

    useEffect(() => {
        if (!fixtureDetails || fixtureDetails.fixtureRoomId !== fixtureRoomId) {
            setFixtureDetails(null);

            calendarService.getFixtureDetails(selectedFixture.bureauMatchId, fixtureRoomId).then((fixtureDetails) => {
                setFixtureDetails(fixtureDetails);
            });
        }
    }, [fixtureRoomId, selectedFixture, fixtures]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3>
                        Delete Training
                    </h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete Training?

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>Close</Button>
                <Button variant="danger" onClick={() => {
                    setFixtures(fixtures.filter(arrayItem => arrayItem.fixtureRoomId !== fixtureRoomId))
                    calendarService.deleteFixtureRoom(fixtureRoomId);
                    onHide();
                }}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )

};

export default DeleteTrainingModal;